import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'

import SecondTimeBookingConfirmation from './SecondTimeBookingConfirmation'
import { fetchAliada } from '@src/redux/modules/aliada'
import {
  create as createService,
  updateNewService,
  getService,
  getPromoCode,
  isCreating as isCreatingService,
  redeemPromoCode,
  isRedeemingPromoCode
} from '@src/redux/modules/service'
import { getUsers, getAliadas } from '@src/redux/modules/entities'
import { display as displayError } from '@src/redux/modules/error'

const mapStateToProps = (state, ownProps) => {
  const { userId } = ownProps.params
  const users = getUsers(state)
  const user = users[userId]

  const service = getService(state)
  const { aliadaId, date, time, estimatedHours, serviceTypeId, weekdays } = service
  const creatingService = isCreatingService(state)

  const promoCode = getPromoCode(state)
  const redeemingPromoCode = isRedeemingPromoCode(state)

  const isFirstService = user.servicesCount === 0

  const aliadas = getAliadas(state)
  const aliada = aliadas[aliadaId]

  return {
    userId,
    user,
    isFirstService,
    aliadaId,
    aliada,
    date,
    time,
    estimatedHours,
    serviceTypeId,
    weekdays,
    promoCode,
    redeemingPromoCode,
    creatingService
  }
}

const mapDispatchToProps = {
  fetchAliada,
  redeemPromoCode,
  updateNewService,
  createService,
  displayError
}

const SecondTimeBookingConfirmationForm = reduxForm({
  form: 'newBooking'
})(SecondTimeBookingConfirmation)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SecondTimeBookingConfirmationForm)



// WEBPACK FOOTER //
// ./src/screens/App/screens/Booking/screens/BookingConfirmation/screens/SecondTimeBookingConfirmation/SecondTimeBookingConfirmationContainer.js